module.exports = __webpack_public_path__ + "img/9.84f797be.jpg";